import {Component, OnInit, ViewChild} from '@angular/core';
import {
  PoMenuItem,
  PoModalAction,
  PoModalComponent,
  PoTableColumn,
  PoToolbarAction,
  PoToolbarProfile
} from '@po-ui/ng-components';
import {PoStorageService} from '@po-ui/ng-storage';
import {MenuMaisti} from '../interface/menu-maisti';
import {Empresa, Privilegio} from '../interface/usuario';
import { environment } from 'src/environments/environment';
import { PO_ADMINISTRADOR, PO_AVALIA_CLIFOR_MENU, PO_NETRIN_ATUA_CLI_FOR, PO_COMPRAS_MENU, PO_DDA_MENU, PO_ESTOQUE, PO_ESTOQUE_MENU, PO_EXPEDICAO, PO_FINANCEIRO_MENU, PO_GUARITA, PO_LIBPED, PO_LISTAUR_MENU, PO_PCP, PO_PCP_ETIQ_MP_FORN1, PO_PCP_MENU, PO_PC_MENU, PO_PC_PAINEL_APROVACAO, PO_PEDVENDA, PO_PRECAD_PRODUTO_MENU, PO_PROCESSOCADASTRO_MENU, PO_QUALIDADE, PO_REVCAD_CLIFOR_MENU, PO_SC_APROVADOR, PO_SC_MENU, PO_NETRIN_SUB_MENU, PO_NETRIN_CONS_CLI_FOR } from '../auth/permissao';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  title: string;
  itens: Array<Empresa>;
  profile: PoToolbarProfile | undefined;

  actions: Array<PoToolbarAction>;


  constructor(private poStorageService: PoStorageService) {
    this.itens = [];
    this.title = '';
    this.actions = [
      {label: 'Selecione', action: this.openModal.bind(this)},
    ];

    const empresaSelecionadaJson = localStorage.getItem('empresaSelecionada');

    if (empresaSelecionadaJson) {
      const empresaSelecionada = JSON.parse(empresaSelecionadaJson);
      if(environment.production){
        this.title = `${empresaSelecionada.CM0FILIAL} - ${new Date().toLocaleDateString()}`;
      }else{
        this.title = `${empresaSelecionada.CM0FILIAL} - ${new Date().toLocaleDateString()} <<---- BASE DE TESTE ---->>`;
      }
      this.actions = [
        {label: empresaSelecionada.CM0FILIAL, action: this.openModal.bind(this)},
      ];
    }

    this.poStorageService.get('usuario').then(usuario => {
      this.profile = {
        subtitle: usuario.CUSRID,
        title: usuario.CUSRNOME
      };
    });

  }

  public readonly profileActions: Array<PoToolbarAction> = [
    {icon: 'po-icon-exit', label: 'Sair', type: 'danger', separator: true, action: this.logout.bind(this)}
  ];

  @ViewChild(PoModalComponent, {static: true}) poModal: PoModalComponent | undefined;

  close: PoModalAction = {
    action: () => {
      this.poModal?.close();
    },
    label: 'Cancelar',
    danger: true
  };

  // [*MainMenu]
  readonly menus: Array<MenuMaisti> = [
    {
      icon: 'po-icon-list',label: 'Cadastro', shortLabel: 'PCA', codigos: PO_PROCESSOCADASTRO_MENU ,
      subItems: [
        {label: 'Pré Cad Produto'               , icon: 'po-icon po-icon-clipboard', link: 'administrativo/pre-cadastro/produto/lista'                    , codigos: PO_PRECAD_PRODUTO_MENU} ,
        {label: 'Pré Cad Cliente'               , icon: 'po-icon po-icon-clipboard', link: 'administrativo/pre-cadastro/cliente/lista'                    , codigos: PO_REVCAD_CLIFOR_MENU},
        {label: 'Pré Cad Fornecedor'            , icon: 'po-icon po-icon-clipboard', link: 'administrativo/pre-cadastro/fornecedor/lista'                 , codigos: PO_REVCAD_CLIFOR_MENU},
        {label: 'Rev Cad Forn/Cliente'          , icon: 'po-icon po-icon-clipboard', link: '/administrativo/revisao-cadastro/lista'                       , codigos: PO_REVCAD_CLIFOR_MENU},
        {label: 'Rev Cad Produto'               , icon: 'po-icon po-icon-clipboard', link: '/administrativo/revisao-cadastro/produto/lista'               , codigos: PO_PRECAD_PRODUTO_MENU},
        {label: 'Validação Cad Cli/For'         , icon: 'po-icon po-icon-clipboard', link: '/administrativo/validacao-cadastro/cliente-fornecedor/lista'  , codigos: PO_AVALIA_CLIFOR_MENU},
        {
          label: 'Atu. Cadastral - Netrin', icon: 'po-icon po-icon-clipboard', link: '/administrativo/atualizacao-cadastro/lista'                   , codigos: PO_NETRIN_SUB_MENU,
          subItems: [
            { label: 'Consulta Dados'     , link: '/administrativo/netrin/consulta-api'        , codigos: PO_NETRIN_CONS_CLI_FOR  },
            { label: 'Atualizar Cadastro'  , link: '/administrativo/netrin/atualizacao-cadastro', codigos: PO_NETRIN_ATUA_CLI_FOR  },
          ]
        },
      ]
    },
    {
      icon: 'po-icon-list',label: 'Guarita', shortLabel: 'GUA', codigos: PO_GUARITA,
      subItems: [
        {label: 'Pedidos' , icon: 'po-icon po-icon-clipboard',  link: '/faturamento/guarita'      , codigos: PO_GUARITA},
        {label: 'Notas'   , icon: 'po-icon po-icon-clipboard',  link: '/faturamento/guarita/notas', codigos: PO_GUARITA},
      ]
    },
    {
      icon: 'po-icon-list',label: 'Ped Venda', shortLabel: 'PED', codigos: PO_PEDVENDA,
      subItems: [
        {label: 'Lista'                   , icon: 'po-icon po-icon-clipboard', link: '/faturamento/pedido-venda/lista'        , codigos: PO_PEDVENDA},
        {label: 'Cadastro'                , icon: 'po-icon po-icon-clipboard', link: '/faturamento/pedido-venda/cadastro'     , codigos: PO_PEDVENDA},
        {label: 'Liberação por Regra'     , icon: 'po-icon po-icon-clipboard', link: '/faturamento/pedido-venda/liberacao-por-regra' , codigos: PO_LIBPED},
        {label: 'Rel. Saídas Fazendas'    , icon: 'po-icon po-icon-clipboard', link: '/faturamento/relatorios/saidasfazendas' , codigos: PO_PEDVENDA},
      ]
    },
    {
      icon: 'po-icon-list',label: 'Estoque', shortLabel: 'EST', codigos: PO_ESTOQUE_MENU,
      subItems: [
        {
          label: 'Baldeio', codigos: PO_ESTOQUE_MENU,
          subItems: [
            {label: 'Lista'            , icon: 'po-icon-document', link: '/estoque/romaneio/lista'            , codigos: PO_ESTOQUE},
            {label: 'Lista Recebimento', icon: 'po-icon-document', link: '/estoque/romaneio/recebimento/lista', codigos: PO_ESTOQUE},
            {label: 'Controle de Qualidade', icon: 'po-icon-document', link: '/estoque/romaneio/controle-qualidade/lista'       , codigos: PO_QUALIDADE},
          ]
        },
        {
          label: 'Expedição', codigos: PO_ESTOQUE,
          subItems: [
            {label: 'Alterar Pedido/Armazém', codigos: PO_EXPEDICAO,
              subItems: [
                {label: 'Por Lote'         , icon: 'po-icon-document', link: '/estoque/expedicao/altera-pedido'     , codigos: PO_EXPEDICAO},
                {label: 'Por Pedido'       , icon: 'po-icon-document', link: '/estoque/expedicao/pedido-para-pedido', codigos: PO_EXPEDICAO},
              ]
            },
            {label: 'Romaneio ME'             , icon: 'po-icon-document', link: '/estoque/expedicao/romaneio-cliente'                   , codigos: PO_EXPEDICAO},
            {label: 'Programação Carreg. ME'  , icon: 'po-icon-document', link: '/estoque/expedicao/programacao-carregamento-me/lista'  , codigos: PO_EXPEDICAO},
            {label: 'Carregamentos ME'        , icon: 'po-icon-document', link: '/estoque/expedicao/carregamentos-me/lista'             , codigos: PO_EXPEDICAO},
            {label: 'Romaneio MI'             , icon: 'po-icon-document', link: '/estoque/expedicao/romaneio-mi'                        , codigos: PO_EXPEDICAO},
            {label: 'Controle de Danos'       , icon: 'po-icon-document', link: '/estoque/expedicao/danos/lista'                        , codigos: PO_ESTOQUE},
            {label: 'Lista UR'                , icon: 'po-icon-document', link: '/estoque/expedicao/ur/lista'                           , codigos: PO_LISTAUR_MENU},
            {label: 'Progr. Pedido'           , icon: 'po-icon-document', link: '/faturamento/pedido-venda/programacao'                 , codigos: PO_ESTOQUE},
          ]
        },
        {
          label: 'Relatórios', codigos: PO_ESTOQUE,
          subItems: [
            {label: 'Baldeio'                   , icon: 'po-icon-document', link: '/estoque/romaneio/relatorio/baldeio'                 , codigos: PO_ESTOQUE},
            {label: 'Lotes'                     , icon: 'po-icon-document', link: '/estoque/romaneio/relatorio/lotes'                   , codigos: PO_ESTOQUE},
            {label: 'Lotes Vs Estoque'          , icon: 'po-icon-document', link: '/estoque/romaneio/relatorio/lotes-vs-estoque'        , codigos: PO_ESTOQUE},
            {label: 'MI'                        , icon: 'po-icon-document', link: '/estoque/expedicao/romaneio-mi/relatorio'            , codigos: PO_EXPEDICAO},
            {label: 'Saldo Expedição'           , icon: 'po-icon-document', link: '/estoque/armazem/relatorio/saldo'                    , codigos: PO_ESTOQUE},
            {label: 'Transferências Expedição'  , icon: 'po-icon-document', link: '/estoque/armazem/relatorio/transferencias-expedicao' , codigos: PO_ESTOQUE},
            {label: 'Inconsistências'           , icon: 'po-icon-document', link: '/estoque/armazem/relatorio/inconsistencias'          , codigos: PO_ADMINISTRADOR},
          ]
        }
      ]
    },
    {
      icon: 'po-icon-list',label: 'PCP', shortLabel: 'PCP', codigos: PO_PCP_MENU,
      subItems: [
        {label: 'Integração GTR'    , icon: 'po-icon po-icon-document', link: '/pcp/integracao-gtr/lista'                , codigos: PO_PCP},
        {label: 'Etq MP Fornecedor' , icon: 'po-icon po-icon-document', link: '/pcp/etiqueta/materia-prima-fornecedor-1' , codigos: PO_PCP_ETIQ_MP_FORN1},
      ]
    },
    {
      icon: 'po-icon-list',label: 'Compras', shortLabel: 'CMP', codigos: PO_COMPRAS_MENU,
      subItems: [
        {label: 'Solicitação de Compra' , icon: 'po-icon po-icon-document', link: '/compras/solicitacao-compra/lista'   , codigos: PO_SC_MENU},
        {label: 'Aprovar SC'            , icon: 'po-icon po-icon-document', link: '/compras/solicitacao-compra/aprovar' , codigos: PO_SC_APROVADOR},
        {label: 'Pedido de Compra'      , icon: 'po-icon po-icon-document', link: '/compras/pedido-compra/lista'        , codigos: PO_PC_MENU},
        {label: 'Painel Aprovação'      , icon: 'po-icon po-icon-document', link: '/compras/painel-aprovacao'           , codigos: PO_PC_PAINEL_APROVACAO },
      ]
    },
    {
      icon: 'po-icon-list',label: 'Financeiro', shortLabel: 'FIN', codigos: PO_FINANCEIRO_MENU,
      subItems: [
        {label: 'Manutenção DDA' , icon: 'po-icon po-icon-document', link: 'financeiro/dda/lista'   , codigos: PO_DDA_MENU},
      ]
    },
  ];

  menusFiltrados: Array<MenuMaisti> = [];

  public readonly empresaColumns: Array<PoTableColumn> =
    [
      {property: 'CM0CODIGO', label: 'Codigo'       , width: '10%'},
      {property: 'CM0CODFIL', label: 'Codigo Filial', width: '15%'},
      {property: 'CM0CGC'   , label: 'CNPJ'         , width: '15%'},
      {property: 'CM0NOME'  , label: 'Empresa'      , width: '20%'},
      {property: 'CM0FILIAL', label: 'Filial'       , width: '40%'},

    ];

  ngOnInit(): void {
    this.poStorageService.get('usuario').then(usuario => {
      this.menuFilter(usuario.APRIVILEGIO);
    });
  }

  menuFilter(filters: Array<Privilegio> = []): void {
    this.menusFiltrados = this.menus.filter((menu) => {
      return filters.some(
        (permissao) => menu.codigos && menu.codigos.includes(permissao.CCODIGO)
      );
    });
    this.menusFiltrados.map((subMenus) => {
      if (subMenus.subItems && subMenus.subItems.length) {
        subMenus.subItems = subMenus.subItems.filter((menu) => {
          return filters.some(
            (permissao) =>
              menu.codigos && menu.codigos.includes(permissao.CCODIGO)
          );
        });
      }
    });
  }

  openModal(): void {
    this.poStorageService.get('usuario').then(usuario => {
      if (usuario && usuario.AEMPRESA) {
        this.itens = usuario.AEMPRESA;
        this.poModal?.open();
      }
    });
  }

  empresaSelecionada(row: Empresa): void {
    localStorage.setItem('empresaSelecionada', JSON.stringify(row));
    const {CM0CODIGO, CM0CODFIL} = row;
    localStorage.setItem('tenantid', `${CM0CODIGO},${CM0CODFIL}`);

    this.poModal?.close();
    window.location.reload();
  }

  logout(): void {
    localStorage.clear();
    this.poStorageService.clear();
    window.location.reload();
  }

}
